


// Simulates progressbar loader
export function runProgressBar(progressBar,sleep) {
    let counter=10;
    progressBar.targetValue = 100;
    progressBar.show();
    while (counter < 100) {
        progressBar.value = counter; 
        setTimeout(() => {progressBar.value = counter;}, sleep);
        counter = counter+10;   
    } 
    setTimeout(() => {progressBar.hide();}, sleep);
}

